/**
 * @return {number} data convert
 */
export function CelsiusToFahrenheit(data) {
    const value = (data * 9/5) + 32;
    return Math.round(value * 10) / 10;
}

/**
 * @return {number} data convert
 */
export function FahrenheitToCelsius(data) {
    const value = (data - 32) * (5/9);
    return Math.round(value * 10) / 10;
}

/**
 *
 * @param data
 * @param decimals
 * @returns {number} data convert
 * @constructor
 */
export function gramToKg(data, decimals) {
    const value = data / 1000;
    let fraction = 10;
    if (decimals) {
        if (decimals === 2) {
            fraction = 100;
        }
    }
    return Math.round(value * fraction) / fraction;
}

/**
 *
 * @param data
 * @param decimals
 * @returns {number} data convert
 * @constructor
 */
export function gramToLb(data, decimals) {
    const value = data * 0.00220462262185;
    let fraction = 10;
    if (decimals) {
        if (decimals === 2) {
            fraction = 100;
        }
    }
    return Math.round(value * fraction) / fraction;
}

/**
 *
 * @param data
 * @returns {number} data convert
 * @constructor
 */
export function KgToGram(data) {
    return data * 1000;
}

export const VITAL_TEMP = 'Temp';
export const VITAL_W = 'W';
export const VITAL_HR = 'HR';
export const VITAL_RR = 'RR';
export const VITAL_BP = 'BP';

/**
 *
 * @param org
 * @param vital
 * @returns {string}
 */
export function getVitalUnit(org, vital) {
    if (vital === VITAL_TEMP || vital === 'CoreTemp') {
        const unit = !!org && org.temperatureUnit ? org.temperatureUnit : 'F';
        if (unit === 'C') {
            return '°C';
        }
        if (unit === 'F') {
            return '°F';
        }
    }
    if (vital === VITAL_RR) {
        return 'brpm'
    }
    if (vital === VITAL_HR) {
        return 'bpm'
    }
    if (vital === 'SPO2') {
        return '%'
    }
    if (vital === VITAL_BP || vital === 'DBP' || vital === 'SBP') {
        return 'mmHg'
    }
    if (vital === VITAL_W) {
        const unit = !!org && org.weightUnit ? org.weightUnit : 'lb';
        if (unit === 'lb') {
            return 'lbs';
        }
        if (unit === 'kg') {
            return 'kg';
        }
    }
    return '';
}

/**
 *
 * @param org
 * @param vital
 * @param data
 * @returns {number}
 */
export function getVitalData(org, vital, data) {
    if (vital === 'COVID') {
        if (data === -1) {
            return 'INSUFFICIENT DATA';
        }
        return data? 'POSITIVE' : 'NEGATIVE';
    }
    if (vital === VITAL_TEMP || vital === 'CoreTemp') {
        const unit = !!org && org.temperatureUnit ? org.temperatureUnit : 'F';
        if (unit === 'C') {
            return FahrenheitToCelsius(data);
        }
        return Math.round(data * 10) / 10;
    }
    if (vital === VITAL_W) {
        const unit = !!org && org.weightUnit ? org.weightUnit : 'lb';
        const decimals = 1;
        if (unit === 'kg') {
            return gramToKg(data, decimals);
        }
        return gramToLb(data, decimals);
    }
    return Math.round(data);
}